import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class SimpleVisualizatorSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key.length > 0 && key[0] == "_") {
        // special private field
        this[key] = ObjectCreator.shallowCopy(settings[key]);
      } else if (typeof settings[key] !== "function") {
        this[key] = ObjectCreator.deepCopy(settings[key]);
      }
    }
  }

  copy() {
    return new SimpleVisualizatorSettings(this);
  }
}
